import React from 'react';
import carePlusWordmark from '../../../../icons/careplus-wordmark.svg';

interface CarePlusWordmarkProps {
  fontSize?: number;
  topOffset?: number;
}

const CarePlusWordmark: React.FC<CarePlusWordmarkProps> = ({ fontSize = 22.9, topOffset = -4 }) => (
  <img
    src={carePlusWordmark}
    alt="Care+"
    style={{
      height: fontSize,
      width: 'auto',
      display: 'inline-block',
      verticalAlign: 'middle',
      position: 'relative',
      top: topOffset,
    }}
  />
);

export default CarePlusWordmark;
